import { Box } from '@mui/material';
import TypographyComponent from 'components/TypographyComponent';
import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface TextAreaComponentV2Props {
  onChangeVal: (val: string) => void;
  label?: string;
  value?: string;
}

const TextAreaComponentV2 = ({
  onChangeVal,
  label,
  value,
}: TextAreaComponentV2Props) => {
  const modules = {
    toolbar: [
      [{ header: '1' }, { header: '2' }, { font: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['bold', 'italic', 'underline', 'strike'],
      ['emoji'],
      [{ align: [] }],
      ['link', 'image'],
    ],
    'emoji-textarea': true,
  };

  const onChange = (val: string) => {
    onChangeVal(val);
  };

  return (
    <>
      {label && (
        <Box sx={{ mb: 1 }}>
          <TypographyComponent variant="h5">{label}</TypographyComponent>
        </Box>
      )}
      <ReactQuill
        value={value}
        onChange={onChange}
        placeholder="Digite algo..."
        style={{
          color: '#000',
          background: 'white',
          borderRadius: '8px',
          border: '1px solid #ccc',
        }}
      />
    </>
  );
};

export default TextAreaComponentV2;
